import logoSrc from '../assets/logo.svg';

const ParabolaLogo = ({ width = 161, height = 57, ...props }) => (
  <img src={logoSrc} alt="Парабола" width={width} height={height} {...props} />
);

export default ParabolaLogo;
